import { parsePhoneNumberFromString } from "libphonenumber-js";

export const emailValidationPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
export const phoneValidationPattern = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,30}(\s*)?$/;

/**
 * Whether this is a real phone number that can receive an SMS.
 *
 * Uses libphonenumber-js rather than a pattern or `validator.isMobilePhone`:
 * both of those only check shape, so they accept a number with a plausible
 * length and an impossible national prefix. libphonenumber carries Google's
 * per-country numbering plans and rejects those — which matters here because the
 * number is where a verification code goes, and a shape-valid but nonexistent
 * number fails at the carrier long after the form said it was fine.
 *
 * The country code is required: without one there is no numbering plan to check
 * the national part against, so a bare local number is rejected.
 *
 * `FIXED_LINE` is rejected to keep the intent of the `isMobilePhone` check this
 * replaced. Anything else valid is accepted, including `FIXED_LINE_OR_MOBILE` —
 * plenty of plans (the whole NANP among them) do not separate the two, so
 * demanding `MOBILE` would reject every US number.
 */
export const isValidPhoneNumber = (value: string): boolean => {
  const parsed = parsePhoneNumberFromString(value.trim());

  if (!parsed?.isValid()) return false;

  return parsed.getType() !== "FIXED_LINE";
};
export const websiteValidationPattern = /^(ftp|http[s]?):\/\/[^\s/$.?#].[^\s]*($|\s|%20)/;
export const allowedProtocols = ["http://", "https://", "ftp://"];

export const numberValidationPattern = /^[+-]?\d+(\.\d+)?$/;
export const integerValidationPattern = /^[0-9]+$/;
export const alphanumericValidationPattern = /^[a-zA-Z0-9]+$/;

export const youtubeUrlValidationPattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|.+\?v=)?([^#&?]{11})(.*)?$/;
export const vimeoUrlValidationPattern = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;

export const fileExtensionPattern = /[0-9a-z]+$/i;

export const trimValidationPattern = /^(?!\s*$).*$/;
export const versionValidationPattern = /^(\d+)\.(\d+)\.(\d+)$/;

export const hexValidationPattern = /^([A-Fa-f0-9]{0,6})$/;
export const aspBaseUrlValidationPattern = /^(?!.*__zone\/sso).*$/;

export { createDebouncedAsyncValidator } from "./createDebouncedAsyncValidator";
